import NewBreadCrumbs from '@/PageComponents/Layout/Breadcrumbs';

function Breadcrumbs(props: any) {
  return <NewBreadCrumbs {...props} />
}


export default Breadcrumbs
